import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useCompanyVerificationTracking } from '../hooks/useCompanyVerificationTracking';
import TextField from './TextField';

type Props = {
  disabled?: boolean;
};

export function CompanyNPWPNumberField({ disabled }: Props) {
  const { formatMessage } = useIntl();

  const { trackOnFieldValid } = useCompanyVerificationTracking();
  const npwpNumberFieldName = 'verifyWithLegalDocuments.companyNPWPNumber';
  const npwpNumberOnBlur = trackOnFieldValid(
    npwpNumberFieldName,
    'verification_legal_document_number_filled',
    // eslint-disable-next-line camelcase
    { number_type: 'company_registration_number' }
  );

  return (
    <TextField
      fullWidth={true}
      title={
        <FormattedMessage
          id="text-company-npwp-number"
          defaultMessage="Company NPWP Number"
        />
      }
      isRequired={true}
      placeholder={formatMessage({
        id: 'text-placeholder-npwp-number',
        defaultMessage: 'Enter NPWP Number',
      })}
      fieldName={npwpNumberFieldName}
      disabled={disabled}
      onBlur={npwpNumberOnBlur}
    />
  );
}
